import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'medicines',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'medicines-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.medicines-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "medicines-index" */ '@/modules/configurations/catalogs/medicines/views/index.vue')
        }
    ]
}